import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'bem-classnames';

import {
  AutoControlledComponent as Component,
  childrenUtils,
  createShorthandFactory,
  getElementType,
  getUnhandledProps,
} from 'components/lib';
import MenuItem from './MenuItem';

import './Menu.scss';

/* eslint-disable react/prefer-stateless-function */
class Menu extends Component {
  static propTypes = {
    /** Index of the currently active item. */
    activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Initial activeIndex value. */
    defaultActiveIndex: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  };

  static autoControlledProps = ['activeIndex'];

  static handledProps = ['items', 'activeIndex', 'onItemClick'];

  static Item = MenuItem;

  handleItemOverrides = predefinedProps => ({
    onClick: (e, itemProps) => {
      const index = 0;

      this.trySetState({ activeIndex: index });

      _.invoke(predefinedProps, 'onClick', e, itemProps);
      _.invoke(this.props, 'onItemClick', e, itemProps);
    },
  });

  renderItems() {
    const { items } = this.props;
    const { activeIndex } = this.state;
    const length = 100 / items.length;
    return _.map(items, (item, index) =>
      MenuItem.create(item, {
        defaultProps: {
          active: parseInt(activeIndex, 10) === index,
          index,
          style: {width: `${length}%`}
        },
        overrideProps: this.handleItemOverrides,
      }),
    );
  }

  render() {
    const { children, className } = this.props;
    const classes = cx({ name: 'menu', modifiers: [''] },
      this.props,
      className,
    );
    const rest = getUnhandledProps(Menu, this.props);
    const ElementType = getElementType(Menu, this.props);

    return (
      <ElementType {...rest} className={classes}>
        {childrenUtils.isNil(children) ? this.renderItems() : children}
      </ElementType>
    );
  }
}

Menu.create = createShorthandFactory(Menu, items => ({ items }));

export default Menu;
